import Select, { components } from "react-select";
import React, { useState } from "react";
import PropTypes from 'prop-types';
import { hasFlag } from "country-flag-icons";
import Flags from "country-flag-icons/react/3x2";
import { DropdownIndicator } from "../../../../lib/helpers";
import { Icon } from './../Icon/Icon';
import { countries_other } from "../../../../data/countries_other";
import { CountryChips } from './../CountryChips/CountryChips';
import { nationalities_other } from "../../../../data/nationalities_other";

const CustomValueContainer = ({ children, ...props }) => {
    const { ValueContainer, Placeholder } = components;

    return (
        <ValueContainer {...props}>
            <Placeholder {...props} isFocused={props.isFocused}>
                {props.selectProps.placeholder}
            </Placeholder>
            {React.Children.map(children, child =>
                child && child.type !== Placeholder ? child : null
            )}
        </ValueContainer>
    );
};

export const CountryDropdown = ({ id, isMulti = true, type = "country", onChange, value, active, menuIsOpen = false, categories, isMenaUser = true }) => {

    const [input, setInput] = useState("");

    let selected_value = null;

    if (isMulti) {
        selected_value = [];
        if (type === "nationality") {
            value.forEach((item) => {
                selected_value.push({ label: item, value: item });
            });
        } else {
            value.forEach((item) => {
                selected_value.push({ label: item, value: item });
            });
        }
    } else {
        if (value) {
            selected_value = { label: value, value: value };
        }
    }

    var options = null;
    if (type === "nationality") {
        options = nationalities_other
            .map((country) => {
                if (!hasFlag(country["code"])) return undefined;
                const Component = Flags[country["code"]];
                const isDisabled = selected_value.findIndex(item => item.value === country.value) !== -1;

                return {
                    value: country["value"],
                    label: (
                        <><span className="country-flag-icon">
                            <Component
                                title={country["code"]}
                                style={{ display: "inline-block", height: "1em", width: "1em" }}
                            />
                        </span>
                            &nbsp;
                            <span>{`${country["value"]}`}</span>
                        </>
                    ),
                    isDisabled,
                };
            })
            .filter(Boolean);
    } else {
        options = countries_other
            .filter((country) => {
                if (isMenaUser && (country.value === "United Arab Emirates" || country.value === "Saudi Arabia")) {
                    return false;
                }
                return true;
            })
            .map((country) => {
                if (!hasFlag(country["code"])) return undefined;
                const Component = Flags[country["code"]];
                const isDisabled = selected_value.findIndex(item => item.value === country.value) !== -1;

                return {
                    value: country["value"],
                    label: (
                        <><span className="country-flag-icon">
                            <Component
                                title={country["code"]}
                                style={{ display: "inline-block", height: "1em", width: "1em" }}
                            />
                        </span>
                            &nbsp;
                            <span>{`${country["value"]}`}</span>
                        </>
                    ),
                    isDisabled,
                };
            })
            .filter(Boolean);
    }

    return (
        <div className={`dropdown-container form-group input-field mb-0 ${((value !== '' && value !== null) || active === true) ? 'focused country-with-value' : ''} ${active === true ? 'active' : ''}`} id={id}>
            <div className="input-position-relative dropdown-field country-dropdown">
                {menuIsOpen ? (
                    <Select
                        isMulti={true}
                        isClearable={false}
                        isSearchable={true}
                        isDisabled={false}
                        hideSelectedOptions={false}
                        name="countries"
                        options={options}
                        onChange={onChange}
                        placeholder={type === "nationality" ? "Search nationalities" : "Search"}
                        value={selected_value}
                        menuIsOpen
                        components={{ ValueContainer: CustomValueContainer, DropdownIndicator }}
                        backspaceRemovesValue={false}
                        classNamePrefix="userq-select"
                    />
                ) : (
                    <Select
                        key="countrydropdown"
                        isMulti={true}
                        isDisabled={false}
                        hideSelectedOptions={false}
                        name="countries"
                        options={options}
                        onChange={(items) => { setInput(""); onChange(items); }}
                        placeholder={type === "nationality" ? "Search nationalities" : "Search"}
                        value={selected_value}
                        components={{ ValueContainer: CustomValueContainer, DropdownIndicator }}
                        styles={{
                            placeholder: (provided, state) => ({
                                ...provided,
                                display: state.selectProps.inputValue ? "none" : "block",
                            })
                        }}
                        inputValue={input}
                        onInputChange={(value, action) => {
                            if (action.action === "input-change") { setInput(value); }
                        }}
                        backspaceRemovesValue={false}
                        closeMenuOnSelect={type !== "nationality"}
                        classNamePrefix="userq-select"
                    />
                )}
                <span className="input-icon"><Icon value="search" size="medium" hover={true} /></span>
                {input !== "" && (
                    <span className="input-right-icon" onClick={() => { setInput(""); }}>
                        <Icon value="close" size="medium" hover={true} />
                    </span>
                )}
            </div>

            {type === "nationality" ? (
                <>
                    {categories}
                    <div className="dropdown-chips chips-with-flag">
                        {selected_value.map((nationality) => (
                            <React.Fragment key={"nationalitychip" + nationality.value}>
                                <CountryChips
                                    title={nationality.value}
                                    countrydetails={nationalities_other.filter(x => x.label === nationality.value)}
                                    type="icon-right"
                                    onRemove={() => {
                                        const new_selected = selected_value.filter(item => item.value !== nationality.value);
                                        if (onChange) onChange(new_selected);
                                    }}
                                />
                            </React.Fragment>
                        ))}
                    </div>
                </>
            ) : (
                <div className="dropdown-chips">
                    {selected_value.map((country) => (
                        <CountryChips
                            key={"countrychip" + country.value}
                            title={country.value}
                            countrydetails={countries_other.filter(x => x.label === country.value)}
                            type="icon-right"
                            onRemove={() => {
                                const new_selected = selected_value.filter(item => item.value !== country.value);
                                if (onChange) onChange(new_selected);
                            }}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

CountryDropdown.propTypes = {
    id: PropTypes.string,
    onChange: PropTypes.func,
    inactive: PropTypes.bool,
    focussed: PropTypes.bool,
    open: PropTypes.bool,
    isMulti: PropTypes.bool,
    menuIsOpen: PropTypes.bool,
    type: PropTypes.string,
    isMenaUser: PropTypes.bool,
};
